import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { downgradeInjectable } from '@angular/upgrade/static'
import { TransitTime } from '@tradecafe/types/core'
import { AngularCopy } from 'src/decorators/angular-copy.decorator'
import { AngularParams, HaveAngularParams } from 'src/decorators/angular-params.decorator'
import { environment } from 'src/environments/environment'


const { apiUrl } = environment


export default module =>
  module.service('TransitTimeApi', downgradeInjectable(TransitTimeApiService))


@Injectable()
@AngularCopy()
export class TransitTimeApiService {
  private http = inject(HttpClient)


  @HaveAngularParams()
  list(@AngularParams() params) {
    return this.http.get<{ data: TransitTime[] }>(`${apiUrl}/transit-time`, { params }).toPromise()
  }

  create(data: Partial<TransitTime>) {
    return this.http.post<{ data: TransitTime }>(`${apiUrl}/transit-time`, data).toPromise()
  }

  get(id: string) {
    return this.http.get<{ data: TransitTime }>(`${apiUrl}/transit-time/${id}`).toPromise()
  }

  update(id: string, data: Partial<TransitTime>) {
    return this.http.put<{ data: TransitTime }>(`${apiUrl}/transit-time/${id}`, data).toPromise()
  }

  delete(id: string) {
    return this.http.delete<{ data: TransitTime }>(`${apiUrl}/transit-time/${id}`).toPromise()
  }
}
